module.exports = __webpack_public_path__ + "img/logo.eb1017cc.jpg";